module.exports = __webpack_public_path__ + "img/f.ef48f856.jpg";